(function() {
  var DialogController, Handsontable, RatingsValidator, string_utils,
    bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty,
    indexOf = [].indexOf || function(item) { for (var i = 0, l = this.length; i < l; i++) { if (i in this && this[i] === item) return i; } return -1; };

  DialogController = App.loadClass('core::Angular/DialogController');

  RatingsValidator = App.loadClass('portal::Angular/Ratings/Ratings/RatingsValidator');

  string_utils = App.load('core::utils/string');

  Handsontable = window.Handsontable;

  exports.RatingsDialogController = (function(superClass) {
    extend(RatingsDialogController, superClass);

    function RatingsDialogController(scope, transitions, repo, loader, q, state, modal, timeout1, window1) {
      var deregisterers, ref, self, things_to_load;
      this.scope = scope;
      this.transitions = transitions;
      this.repo = repo;
      this.loader = loader;
      this.q = q;
      this.state = state;
      this.modal = modal;
      this.timeout = timeout1;
      this.window = window1;
      this.exportToExcel = bind(this.exportToExcel, this);
      this._doSave = bind(this._doSave, this);
      this.save = bind(this.save, this);
      this._updateSaveData = bind(this._updateSaveData, this);
      this.setProductCompletion = bind(this.setProductCompletion, this);
      this.checkIfProductIsComplete = bind(this.checkIfProductIsComplete, this);
      this.showInvalidCells = bind(this.showInvalidCells, this);
      this.updateValidationAlert = bind(this.updateValidationAlert, this);
      this.getValidationStatus = bind(this.getValidationStatus, this);
      this.markValid = bind(this.markValid, this);
      this.markIncomplete = bind(this.markIncomplete, this);
      this.markInvalid = bind(this.markInvalid, this);
      this.getValidationMessageWrapper = bind(this.getValidationMessageWrapper, this);
      this.getValidationMessage = bind(this.getValidationMessage, this);
      this._checkCellCompletion = bind(this._checkCellCompletion, this);
      this.validateCell = bind(this.validateCell, this);
      this.validateAllData = bind(this.validateAllData, this);
      this.updateCalculatedColumnsFromChanges = bind(this.updateCalculatedColumnsFromChanges, this);
      this.updateCalculatedColumns = bind(this.updateCalculatedColumns, this);
      this.afterRefugeOptionChange = bind(this.afterRefugeOptionChange, this);
      this.afterRefugePercentChange = bind(this.afterRefugePercentChange, this);
      this.afterChemistryTraitChange = bind(this.afterChemistryTraitChange, this);
      this.afterActiveChange = bind(this.afterActiveChange, this);
      this.afterTreatmentOptionChange = bind(this.afterTreatmentOptionChange, this);
      this.runColumnHooks = bind(this.runColumnHooks, this);
      this.beforeValidate = bind(this.beforeValidate, this);
      this.convertEmptyStrings = bind(this.convertEmptyStrings, this);
      this.beforeChange = bind(this.beforeChange, this);
      this.afterOnCellMouseDown = bind(this.afterOnCellMouseDown, this);
      this.afterChange = bind(this.afterChange, this);
      this.afterInit = bind(this.afterInit, this);
      this._getProductAtCell = bind(this._getProductAtCell, this);
      this._staticOptionComparator = bind(this._staticOptionComparator, this);
      this._statusComparator = bind(this._statusComparator, this);
      this._getDefaultComparatorValue = bind(this._getDefaultComparatorValue, this);
      this._defaultComparator = bind(this._defaultComparator, this);
      this.applySorting = bind(this.applySorting, this);
      this.cancel = bind(this.cancel, this);
      this.updateVisibleProducts = bind(this.updateVisibleProducts, this);
      this.loadNewProducts = bind(this.loadNewProducts, this);
      this.addProduct = bind(this.addProduct, this);
      this.loadProducts = bind(this.loadProducts, this);
      this.getColumnWidth = bind(this.getColumnWidth, this);
      this.getColumnRenderer = bind(this.getColumnRenderer, this);
      this.formatColumn = bind(this.formatColumn, this);
      this.updateCategories = bind(this.updateCategories, this);
      this.getRefugeOptions = bind(this.getRefugeOptions, this);
      this.getTreatmentOptions = bind(this.getTreatmentOptions, this);
      this.preprocessColumn = bind(this.preprocessColumn, this);
      this.loadConfiguration = bind(this.loadConfiguration, this);
      this.showUpdateError = bind(this.showUpdateError, this);
      this.showActivationError = bind(this.showActivationError, this);
      this.showLoadingError = bind(this.showLoadingError, this);
      this.showError = bind(this.showError, this);
      this.showWarning = bind(this.showWarning, this);
      this.showSuccess = bind(this.showSuccess, this);
      this.showInfo = bind(this.showInfo, this);
      RatingsDialogController.__super__.constructor.call(this, this.scope, this.transitions);
      self = this;
      this.scope.fullpage = true;
      this.scope.visible_products = [];
      if (((ref = this.scope.selected.crop) != null ? ref.lineups_id : void 0) == null) {
        this.state.go('portal.ratings.ratings');
        return;
      }
      this.loader.overMap('Loading...');
      things_to_load = [this.loadConfiguration(this.scope.selected.crop), this.loadProducts(this.scope.selected.crop)];
      this.q.all(things_to_load).then((function(_this) {
        return function(result) {
          return _this.validateAllData().then(function() {
            return _this.loader.hideAll();
          });
        };
      })(this));
      this.scope.categories = [];
      this.scope.table_width = 100;
      this.scope.fixed_headings = [];
      this.scope.scrolling_headings = [];
      this.scope.edited_by = '';
      this.scope.$watch('selected.crop.edited_by', (function(_this) {
        return function(val) {
          return _this.scope.edited_by = val;
        };
      })(this));
      this.scope.edited_at = '';
      this.scope.$watch('selected.crop.edited_at', (function(_this) {
        return function(val) {
          var base;
          return _this.scope.edited_at = typeof (base = moment(val)).format === "function" ? base.format('YYYY-MM-DD h:mma') : void 0;
        };
      })(this));
      this.scope.products = [];
      this.scope.show_inactive_products = false;
      this.scope.has_inactive_products = false;
      this.scope.addProduct = this.addProduct;
      this.scope.exportToExcel = this.exportToExcel;
      this.all_columns = {};
      this.has_refuge_columns = false;
      this.column_groups = {
        with_lengths: [],
        chemistry: [],
        refuge_percent: [],
        refuge_option: []
      };
      this.sort_props = ['seed_company', 'name', 'trait_package'];
      this.sort_direction = 'asc';
      this.validator = new RatingsValidator(this.scope.products, this.all_columns, this.column_groups);
      this.validating_all_cells = false;
      this._cached_validation_status_callbacks = [];
      this._cached_changes = [];
      this._cached_validation_statuses = [];
      this.save_data = [];
      this.state_name = this.state.current.name;
      this.scope.hot_settings = {
        currentColClassName: 'highlighted',
        currentRowClassName: 'highlighted',
        allowInsertColumn: false,
        allowRemoveColumn: false,
        allowInsertRow: false,
        allowRemoveRow: false,
        rowHeaders: false,
        wordWrap: false,
        allowInvalid: true,
        invalidCellClassName: 'invalid',
        undo: false,
        afterInit: function() {
          self.hot = this;
          return self.afterInit();
        },
        afterChange: this.afterChange,
        afterOnCellMouseDown: this.afterOnCellMouseDown,
        beforeChange: this.beforeChange,
        beforeValidate: this.beforeValidate
      };
      this.scope.$watch('categories', (function(_this) {
        return function(cats) {
          return _this.updateCategories(cats);
        };
      })(this), true);
      this.scope.$watch('show_inactive_products', (function(_this) {
        return function(show_inactive) {
          _this.updateVisibleProducts();
          return _this.updateValidationAlert();
        };
      })(this));
      deregisterers = [
        this.scope.$on('ratings.add-product:saved', (function(_this) {
          return function(event, data) {
            var ids;
            ids = _.map(data.saved_products, function(product) {
              return product.id;
            });
            _this.loadNewProducts(_this.scope.selected.crop, ids);
            return _this.state.go('portal.ratings.ratings.dialog');
          };
        })(this)), this.scope.$on('ratings.add-product:cancelled', (function(_this) {
          return function(event, data) {
            return _this.state.go('portal.ratings.ratings.dialog');
          };
        })(this))
      ];
      this.transitionStart = this.transitions.onStart({}, (function(_this) {
        return function($transition) {
          if (string_utils.startsWith($transition.to().name, _this.state_name)) {
            return;
          }
          if (_this.save_data.length > 0) {
            if (!_this.window.confirm('You have unsaved changes.\n\nAre you sure you want to leave this page?')) {
              return false;
            }
          }
        };
      })(this));
      this.window.onbeforeunload = (function(_this) {
        return function() {
          if (_this.save_data.length > 0) {
            return 'You have unsaved changes.';
          }
          return null;
        };
      })(this);
      this.scope.$on('$destroy', (function(_this) {
        return function() {
          var func, j, len;
          for (j = 0, len = deregisterers.length; j < len; j++) {
            func = deregisterers[j];
            func();
          }
          _this.transitionStart();
          return _this.window.onbeforeunload = null;
        };
      })(this));
    }

    RatingsDialogController.prototype.showInfo = function(msg) {
      return this.setAlert({
        type: 'info',
        msg: msg
      });
    };

    RatingsDialogController.prototype.showSuccess = function(msg) {
      return this.setAlert({
        type: 'success',
        msg: msg
      });
    };

    RatingsDialogController.prototype.showWarning = function(msg) {
      return this.setAlert({
        type: 'warning',
        msg: msg
      });
    };

    RatingsDialogController.prototype.showError = function(msg, timeout) {
      if (timeout == null) {
        timeout = null;
      }
      return this.setAlert({
        type: 'error',
        msg: msg
      }, timeout);
    };

    RatingsDialogController.prototype.showLoadingError = function(items, msg) {
      if (msg == null) {
        msg = null;
      }
      if (msg != null) {
        msg = "Failed to load " + items + ": " + msg;
      } else {
        msg = "Failed to load " + items;
      }
      return this.showError(msg);
    };

    RatingsDialogController.prototype.showActivationError = function(item, activating, msg) {
      var action;
      if (msg == null) {
        msg = null;
      }
      action = activating ? 'activate' : 'deactivate';
      if (msg != null) {
        msg = "Failed to " + action + " " + item + ": " + msg;
      } else {
        msg = "Failed to " + action + " " + item;
      }
      return this.showError(msg);
    };

    RatingsDialogController.prototype.showUpdateError = function(items, msg) {
      if (msg == null) {
        msg = null;
      }
      if (msg != null) {
        msg = "Failed to update " + items + ": " + msg;
      } else {
        msg = "Failed to update " + items;
      }
      return this.showError(msg);
    };

    RatingsDialogController.prototype.loadConfiguration = function(crop) {
      var promise;
      promise = this.repo.getConfiguration(crop.lineups_id).then((function(_this) {
        return function(response) {
          var arr, cat, col, column, head, j, k, key, l, len, len1, len2, prop, ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, results;
          if (((ref = response.status) != null ? ref.type : void 0) !== 'success') {
            _this.showLoadingError('Rating Column Configuration', (ref1 = response.status) != null ? ref1.msg : void 0);
            return;
          }
          _this.has_refuge_columns = _.find(response.data.categories, {
            display_name: 'Refuge'
          }) != null;
          ref2 = _this.all_columns;
          for (prop in ref2) {
            column = ref2[prop];
            _this.all_columns[prop] = null;
            delete _this.all_columns[prop];
          }
          _this.column_groups.with_lengths.length = 0;
          _this.column_groups.chemistry.length = 0;
          _this.column_groups.refuge_percent.length = 0;
          _this.column_groups.refuge_option.length = 0;
          ref3 = response.data.categories;
          for (j = 0, len = ref3.length; j < len; j++) {
            cat = ref3[j];
            ref4 = cat.headings;
            for (k = 0, len1 = ref4.length; k < len1; k++) {
              head = ref4[k];
              ref5 = head.columns;
              for (l = 0, len2 = ref5.length; l < len2; l++) {
                col = ref5[l];
                _this.all_columns[col.column_alias] = col;
              }
            }
          }
          ref6 = _this.all_columns;
          for (prop in ref6) {
            col = ref6[prop];
            _this.preprocessColumn(col);
          }
          ref7 = response.data;
          results = [];
          for (key in ref7) {
            arr = ref7[key];
            results.push(_this.scope[key] = arr);
          }
          return results;
        };
      })(this))["catch"]((function(_this) {
        return function(response) {
          return _this.showLoadingError('Rating Column Configuration');
        };
      })(this));
      return promise;
    };

    RatingsDialogController.prototype.preprocessColumn = function(column) {
      var possible_chemistry_columns, possible_refuge_option_columns, possible_refuge_percent_columns, ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref_column;
      possible_chemistry_columns = ['glyphosate', 'glufosinate', 'roundup_ready_2_xtend', 'roundup_ready_2_yield', 'libertylink', 'enlist', 'dicamba'];
      possible_refuge_percent_columns = ['refuge_percent', 'refuge_percent_south'];
      possible_refuge_option_columns = ['refuge_option_1', 'refuge_option_2', 'refuge_option_3', 'refuge_option_4', 'refuge_option_5'];
      if (string_utils.endsWith(column.class_name, 'Length')) {
        ref_column = column.column_alias.replace(/_length$/, '');
        if (this.all_columns[ref_column] != null) {
          this.column_groups.with_lengths.push(ref_column);
        }
      } else if (ref = column.column_alias, indexOf.call(possible_chemistry_columns, ref) >= 0) {
        this.column_groups.chemistry.push(column.column_alias);
      } else if (ref1 = column.column_alias, indexOf.call(possible_refuge_percent_columns, ref1) >= 0) {
        this.column_groups.refuge_percent.push(column.column_alias);
      } else if (ref2 = column.column_alias, indexOf.call(possible_refuge_option_columns, ref2) >= 0) {
        this.column_groups.refuge_option.push(column.column_alias);
      }
      switch (column.input_type) {
        case 'autocomplete':
          if ((ref3 = column.column_alias) === 'default_treatment' || ref3 === 'secondary_treatment') {
            column.getOptions = this.getTreatmentOptions;
          } else if (ref4 = column.column_alias, indexOf.call(this.column_groups.refuge_option, ref4) >= 0) {
            column.getOptions = this.getRefugeOptions;
          } else if (column.options_alias != null) {
            column.getOptions = (function(_this) {
              return function() {
                return _this.scope[column.options_alias].map(function(option) {
                  return option.name;
                });
              };
            })(this);
          } else {
            throw new Error("No function found to get options for column \"" + column.display_name + "\"");
          }
      }
      switch (column.class_name) {
        case 'TreatmentOption':
          column.afterChange = this.afterTreatmentOptionChange;
      }
      if (this.has_refuge_columns) {
        if (column.column_alias === 'active') {
          return column.afterChange = this.afterActiveChange;
        } else if (ref5 = column.column_alias, indexOf.call(this.column_groups.chemistry, ref5) >= 0) {
          return column.afterChange = this.afterChemistryTraitChange;
        } else if (ref6 = column.column_alias, indexOf.call(this.column_groups.refuge_percent, ref6) >= 0) {
          return column.afterChange = this.afterRefugePercentChange;
        } else if (ref7 = column.column_alias, indexOf.call(this.column_groups.refuge_option, ref7) >= 0) {
          return column.afterChange = this.afterRefugeOptionChange;
        }
      }
    };

    RatingsDialogController.prototype.getTreatmentOptions = function(product) {
      var column, options, prop, ref;
      options = [];
      ref = this.all_columns;
      for (prop in ref) {
        column = ref[prop];
        if (column.class_name === 'TreatmentOption' && product[prop] === true) {
          options.push(column.display_name);
        }
      }
      return options;
    };

    RatingsDialogController.prototype.getRefugeOptions = function(product) {
      var j, len, options, other, ref;
      if (product.is_refuge) {
        return [];
      }
      options = [];
      ref = this.scope.products;
      for (j = 0, len = ref.length; j < len; j++) {
        other = ref[j];
        if (other.isAValidRefugeOptionFor(product, this.column_groups.chemistry, this.column_groups.refuge_percent)) {
          options.push(other.full_name);
        }
      }
      return options;
    };

    RatingsDialogController.prototype.updateCategories = function(categories) {
      var cat, col, column, columns, fixed_cat_width, fixed_cols, fixed_headings, head, head_width, heading, j, k, l, len, len1, len2, ref, ref1, ref2, scrolling_headings, table_width;
      if (this.hot == null) {
        return;
      }
      table_width = 0;
      fixed_cat_width = 0;
      fixed_headings = [];
      scrolling_headings = [];
      columns = [];
      fixed_cols = 0;
      for (j = 0, len = categories.length; j < len; j++) {
        cat = categories[j];
        if (cat.is_fixed || cat.active) {
          ref = cat.headings;
          for (k = 0, len1 = ref.length; k < len1; k++) {
            head = ref[k];
            head_width = 0;
            ref1 = head.columns;
            for (l = 0, len2 = ref1.length; l < len2; l++) {
              col = ref1[l];
              column = this.formatColumn(col);
              columns.push(column);
              if (cat.is_fixed) {
                fixed_cols += 1;
              }
              head_width += column.width;
            }
            if (head_width > 0) {
              heading = {
                display_name: head.display_name,
                width: head_width
              };
              if (cat.is_fixed) {
                fixed_cat_width += head_width;
                fixed_headings.push(heading);
              } else {
                scrolling_headings.push(heading);
              }
            }
            table_width += head_width;
          }
        }
      }
      this.scope.fixed_headings = fixed_headings;
      this.scope.scrolling_headings = scrolling_headings;
      this.scope.table_width = table_width;
      if ((ref2 = this.scope.scrolling_headings[0]) != null) {
        ref2.margin_left = fixed_cat_width;
      }
      this.hot.updateSettings({
        columns: columns,
        fixedColumnsLeft: fixed_cols
      });
      return this.updateValidationAlert();
    };

    RatingsDialogController.prototype.formatColumn = function(column) {
      var hot_column;
      hot_column = {
        title: column.display_name,
        data: column.column_alias,
        type: column.input_type,
        renderer: this.getColumnRenderer(column),
        validator: this.validateCell,
        width: this.getColumnWidth(column)
      };
      if (!column.is_editable) {
        hot_column.readOnly = true;
      }
      switch (column.input_type) {
        case 'autocomplete':
          hot_column.editor = 'betterAutocomplete';
          hot_column.filter = true;
          hot_column.source = (function(_this) {
            return function(query, callback) {
              var product, ref, row;
              row = (ref = _this.hot.getSelected()) != null ? ref[0] : void 0;
              product = _this.hot.getSourceDataAtRow(row);
              if (product) {
                return callback(column.getOptions(product));
              } else {
                return callback([]);
              }
            };
          })(this);
          break;
        case 'numeric':
          hot_column.format = '0[.]0[000000000]';
      }
      return hot_column;
    };

    RatingsDialogController.prototype.getColumnRenderer = function(column) {
      return 'validated' + string_utils.capitalize(column.input_type);
    };

    RatingsDialogController.prototype.getColumnWidth = function(column) {
      var ref;
      if (column.width != null) {
        return column.width;
      }
      switch (column.column_alias) {
        case 'seed_company':
          return 110;
        case 'name':
          return 120;
        case 'trait_package':
          return 100;
        case 'active':
          return 76;
      }
      if (ref = column.column_alias, indexOf.call(this.column_groups.refuge_option, ref) >= 0) {
        return 280;
      }
      if (string_utils.contains(column.column_alias, 'yield_pop')) {
        return 75;
      }
      return 100;
    };

    RatingsDialogController.prototype.loadProducts = function(crop) {
      var promise;
      promise = this.repo.getProducts(crop.lineups_id).then((function(_this) {
        return function(response) {
          var i, j, len, name, product, ref, ref1, ref2, sc, tp;
          if (((ref = response.status) != null ? ref.type : void 0) !== 'success') {
            _this.showLoadingError('Products', (ref1 = response.status) != null ? ref1.msg : void 0);
            return;
          }
          _this.scope.products.length = response.data.products.length;
          ref2 = response.data.products;
          for (i = j = 0, len = ref2.length; j < len; i = ++j) {
            product = ref2[i];
            sc = product.seed_company;
            name = product.name;
            tp = product.trait_package;
            product.full_name = (sc + " " + name + " " + tp).trim();
            _this.updateCalculatedColumns(product);
            _this.scope.products[i] = product;
            if (!product.active) {
              _this.scope.has_inactive_products = true;
            }
          }
          return _this.applySorting();
        };
      })(this))["catch"]((function(_this) {
        return function(response) {
          return _this.showLoadingError('Products');
        };
      })(this));
      return promise;
    };

    RatingsDialogController.prototype.addProduct = function() {
      return this.state.go('portal.ratings.ratings.dialog.add_product', null, {
        location: false
      });
    };

    RatingsDialogController.prototype.loadNewProducts = function(crop, ids) {
      var promise;
      promise = this.repo.getProducts(crop.lineups_id, ids).then((function(_this) {
        return function(response) {
          var j, len, name, product, ref, ref1, ref2, sc, tp;
          if (((ref = response.status) != null ? ref.type : void 0) !== 'success') {
            _this.showLoadingError('New Products', (ref1 = response.status) != null ? ref1.msg : void 0);
            return;
          }
          ref2 = response.data.products;
          for (j = 0, len = ref2.length; j < len; j++) {
            product = ref2[j];
            sc = product.seed_company;
            name = product.name;
            tp = product.trait_package;
            product.full_name = (sc + " " + name + " " + tp).trim();
            _this.updateCalculatedColumns(product);
            _this.scope.products.push(product);
          }
          _this.loader.overMap('Loading...');
          return _this.applySorting(function() {
            return _this.loader.hideAll();
          });
        };
      })(this))["catch"]((function(_this) {
        return function(response) {
          return _this.showLoadingError('New Products');
        };
      })(this));
      return promise;
    };

    RatingsDialogController.prototype.updateVisibleProducts = function() {
      var i, j, k, len, len1, product, ref, ref1;
      if (this.scope.show_inactive_products) {
        this.scope.visible_products.length = this.scope.products.length;
        ref = this.scope.products;
        for (i = j = 0, len = ref.length; j < len; i = ++j) {
          product = ref[i];
          this.scope.visible_products[i] = product;
        }
      } else {
        this.scope.visible_products.length = 0;
        i = 0;
        ref1 = this.scope.products;
        for (k = 0, len1 = ref1.length; k < len1; k++) {
          product = ref1[k];
          if (product.active) {
            this.scope.visible_products[i++] = product;
          }
        }
      }
      return this.hot.updateSettings({
        maxRows: this.scope.visible_products.length
      });
    };

    RatingsDialogController.prototype.cancel = function() {
      if (!this.save_data.length) {
        this.showInfo('No changes detected since last save');
        return;
      }
      this.loader.overMap('Loading...');
      return this.loadProducts(this.scope.selected.crop).then((function(_this) {
        return function(result) {
          _this.save_data = [];
          return _this.validateAllData().then(function() {
            return _this.loader.hideAll();
          });
        };
      })(this));
    };

    RatingsDialogController.prototype.applySorting = function(callback) {
      if (callback == null) {
        callback = null;
      }
      return this.timeout((function(_this) {
        return function() {
          _this.scope.products.sort(function(a, b) {
            var col, j, len, ref, result, sort_prop;
            ref = _this.sort_props;
            for (j = 0, len = ref.length; j < len; j++) {
              sort_prop = ref[j];
              col = _this.all_columns[sort_prop];
              if ((col != null ? col.class_name : void 0) === 'Status') {
                result = _this._statusComparator(a, b);
              } else if ((col != null ? col.options_alias : void 0) != null) {
                result = _this._staticOptionComparator(a, b, sort_prop, col.options_alias);
              } else {
                result = _this._defaultComparator(a, b, sort_prop);
              }
              if (result !== 0) {
                break;
              }
            }
            if (_this.sort_direction === 'desc') {
              return -result;
            }
            return result;
          });
          _this.updateVisibleProducts();
          return typeof callback === "function" ? callback() : void 0;
        };
      })(this));
    };

    RatingsDialogController.prototype._defaultComparator = function(a, b, prop) {
      var a_comp, b_comp;
      a_comp = this._getDefaultComparatorValue(a[prop], b[prop]);
      b_comp = this._getDefaultComparatorValue(b[prop], a[prop]);
      if (a_comp > b_comp) {
        return 1;
      } else if (a_comp < b_comp) {
        return -1;
      } else {
        return 0;
      }
    };

    RatingsDialogController.prototype._getDefaultComparatorValue = function(val, other) {
      var comp_val;
      comp_val = val;
      if (val == null) {
        if (typeof other === 'string' && !$.isNumeric(other)) {
          comp_val = '';
        }
      } else if (typeof val === 'boolean') {
        if (typeof other === 'string' && !$.isNumeric(other)) {
          if (val) {
            comp_val = '1';
          } else {
            comp_val = '';
          }
        }
      } else if (typeof val === 'string') {
        comp_val = val.toLowerCase();
        if ($.isNumeric(val)) {
          if (typeof other !== 'string' || other === '' || $.isNumeric(other)) {
            comp_val = parseFloat(val);
          }
        }
      } else {
        if (typeof other === 'string' && other !== '' && !$.isNumeric(other)) {
          comp_val = String(val);
        }
      }
      return comp_val;
    };

    RatingsDialogController.prototype._statusComparator = function(a, b) {
      var result;
      result = a.active - b.active;
      if (result !== 0) {
        return result;
      }
      return a.is_placeable - b.is_placeable;
    };

    RatingsDialogController.prototype._staticOptionComparator = function(a, b, sort_prop, options_alias) {
      var a_comp, b_comp, ref, ref1;
      a_comp = (ref = _.find(this.scope[options_alias], {
        name: a[sort_prop]
      })) != null ? ref.value : void 0;
      b_comp = (ref1 = _.find(this.scope[options_alias], {
        name: b[sort_prop]
      })) != null ? ref1.value : void 0;
      return a_comp - b_comp;
    };

    RatingsDialogController.prototype._getProductAtCell = function(cell) {
      if (cell.index != null) {
        return this.scope.products[cell.index];
      } else if (cell.row != null) {
        return this.hot.getSourceDataAtRow(cell.row);
      } else {
        return null;
      }
    };

    RatingsDialogController.prototype.afterInit = function() {
      this.hot.check_completion = this.scope.selected.crop.has_spp;
      this.hot.activated_prop = 'active';
      return this.hot.completed_prop = 'is_placeable';
    };

    RatingsDialogController.prototype.afterChange = function(changes, source) {
      var change, j, len;
      if (source === 'loadData' || source === 'external') {
        return changes;
      }
      for (j = 0, len = changes.length; j < len; j++) {
        change = changes[j];
        this._cached_changes.push(change);
      }
      if (this._afterChangeDebounced == null) {
        this._afterChangeDebounced = debounce((function(_this) {
          return function() {
            _this.updateCalculatedColumnsFromChanges(_this._cached_changes);
            _this._updateSaveData(_this._cached_changes);
            _this.runColumnHooks(_this._cached_changes);
            _this._cached_changes = [];
            return _this.scope.$apply();
          };
        })(this));
      }
      this._afterChangeDebounced();
      return changes;
    };

    RatingsDialogController.prototype.afterOnCellMouseDown = function(event, coords, elem) {
      var i, most_recent_prop, new_prop;
      if (coords.row === -1) {
        most_recent_prop = this.sort_props[0];
        new_prop = this.hot.colToProp(coords.col);
        if (new_prop === most_recent_prop) {
          switch (this.sort_direction) {
            case 'asc':
              this.sort_direction = 'desc';
              break;
            default:
              this.sort_direction = 'asc';
          }
        } else {
          i = this.sort_props.indexOf(new_prop);
          if (i > -1) {
            this.sort_props.splice(i, 1);
          }
          this.sort_props.unshift(new_prop);
          this.sort_direction = 'asc';
        }
        this.loader.overMap('Loading...');
        return this.applySorting((function(_this) {
          return function() {
            return _this.loader.hideAll();
          };
        })(this));
      }
    };

    RatingsDialogController.prototype.beforeChange = function(changes, source) {
      var change, i, j, len, old_val, prop, ref, ref1, ref2, row, val;
      if ((((ref = changes[0]) != null ? ref[3] : void 0) != null) && changes[0][3] === '') {
        this.convertEmptyStrings(changes);
      }
      if (source === 'paste' || source === 'autofill') {
        for (i = j = 0, len = changes.length; j < len; i = ++j) {
          change = changes[i];
          if ((change != null ? change.length : void 0) !== 4) {
            continue;
          }
          row = change[0], prop = change[1], old_val = change[2], val = change[3];
          if (((ref1 = this.all_columns[prop]) != null ? ref1.input_type : void 0) === 'checkbox') {
            switch (typeof val) {
              case 'string':
                val = ((ref2 = val.toLowerCase()) === 'true' || ref2 === 'yes' || ref2 === 't' || ref2 === 'y');
                break;
              default:
                val = !!val;
            }
            changes[i] = [row, prop, old_val, val];
          }
        }
      }
      return changes;
    };

    RatingsDialogController.prototype.convertEmptyStrings = function(changes) {
      var change, i, j, len, old_val, prop, ref, row, val;
      for (i = j = 0, len = changes.length; j < len; i = ++j) {
        change = changes[i];
        if ((change != null ? change.length : void 0) !== 4) {
          continue;
        }
        row = change[0], prop = change[1], old_val = change[2], val = change[3];
        if (((ref = this.all_columns[prop]) != null ? ref.input_type : void 0) === 'checkbox') {
          if (val === '') {
            val = false;
          }
          changes[i] = [row, prop, old_val, val];
        }
      }
      return changes;
    };

    RatingsDialogController.prototype.beforeValidate = function(value, row, prop, source) {
      var cell;
      cell = {
        value: value,
        row: row,
        prop: prop
      };
      return cell;
    };

    RatingsDialogController.prototype.runColumnHooks = function(changes) {
      var change, j, len, old_val, prop, ref, results, row, val;
      results = [];
      for (j = 0, len = changes.length; j < len; j++) {
        change = changes[j];
        if ((change != null ? change.length : void 0) !== 4) {
          continue;
        }
        row = change[0], prop = change[1], old_val = change[2], val = change[3];
        results.push((ref = this.all_columns[prop]) != null ? typeof ref.afterChange === "function" ? ref.afterChange.apply(ref, change) : void 0 : void 0);
      }
      return results;
    };

    RatingsDialogController.prototype.afterTreatmentOptionChange = function(row, prop, old_val, val) {};

    RatingsDialogController.prototype.afterActiveChange = function(row, prop, old_val, val) {};

    RatingsDialogController.prototype.afterChemistryTraitChange = function(row, prop, old_val, val) {};

    RatingsDialogController.prototype.afterRefugePercentChange = function(row, prop, old_val, val) {};

    RatingsDialogController.prototype.afterRefugeOptionChange = function(row, prop, old_val, val) {};

    RatingsDialogController.prototype.updateCalculatedColumns = function(product) {
      var column, prop, ref, results;
      ref = this.all_columns;
      results = [];
      for (prop in ref) {
        column = ref[prop];
        if (indexOf.call(this.column_groups.with_lengths, prop) >= 0) {
          results.push(product.updateLength(prop));
        } else {
          results.push(void 0);
        }
      }
      return results;
    };

    RatingsDialogController.prototype.updateCalculatedColumnsFromChanges = function(changes) {
      var change, j, len, old_val, product, prop, results, row, val;
      results = [];
      for (j = 0, len = changes.length; j < len; j++) {
        change = changes[j];
        if ((change != null ? change.length : void 0) !== 4) {
          continue;
        }
        row = change[0], prop = change[1], old_val = change[2], val = change[3];
        if (indexOf.call(this.column_groups.with_lengths, prop) >= 0) {
          product = this.hot.getSourceDataAtRow(row);
          results.push(product.updateLength(prop));
        } else {
          results.push(void 0);
        }
      }
      return results;
    };

    RatingsDialogController.prototype.validateAllData = function(callback) {
      var column, i, j, len, product, prop, ref, ref1, validators;
      validators = [];
      ref = this.scope.products;
      for (i = j = 0, len = ref.length; j < len; i = ++j) {
        product = ref[i];
        ref1 = this.all_columns;
        for (prop in ref1) {
          column = ref1[prop];
          validators.push(this.validateCell({
            value: product[prop],
            index: i,
            prop: prop
          }, null, false));
        }
      }
      return this.q.all(validators);
    };

    RatingsDialogController.prototype.validateCell = function(cell, callback, run_completion_check, get_messages_only) {
      var cell_is_valid, column, messages, product, promise;
      if (callback == null) {
        callback = null;
      }
      if (run_completion_check == null) {
        run_completion_check = true;
      }
      if (get_messages_only == null) {
        get_messages_only = false;
      }
      column = this.all_columns[cell.prop];
      if (column.is_calculated || !column.is_editable) {
        if (typeof callback === "function") {
          callback(true);
        }
        return;
      }
      if (column.validation_rules.length === 0) {
        if (this.hot.check_completion) {
          return this._checkCellCompletion(cell, callback, run_completion_check, get_messages_only);
        }
        if (get_messages_only) {
          return 'No error';
        }
        this.markValid(cell, callback);
        return;
      }
      product = this._getProductAtCell(cell);
      cell_is_valid = true;
      messages = [];
      promise = this.q((function(_this) {
        return function(resolve, reject) {
          var j, len, ref, results, rule_str, rules_finished;
          if (column.validation_rules.length === 0) {
            resolve();
          }
          rules_finished = 0;
          ref = column.validation_rules;
          results = [];
          for (j = 0, len = ref.length; j < len; j++) {
            rule_str = ref[j];
            results.push(_this.validator.validate(rule_str, cell, product, column, get_messages_only, function(is_valid, msg) {
              if (msg == null) {
                msg = null;
              }
              if (!is_valid) {
                cell_is_valid = false;
                if (get_messages_only && (msg != null)) {
                  messages.push(msg);
                }
              }
              rules_finished++;
              if (rules_finished === column.validation_rules.length) {
                return resolve();
              }
            }));
          }
          return results;
        };
      })(this));
      return promise.then((function(_this) {
        return function() {
          if (cell_is_valid) {
            if (_this.hot.check_completion) {
              return _this._checkCellCompletion(cell, callback, run_completion_check, get_messages_only);
            }
            if (get_messages_only) {
              return 'No error';
            }
            return _this.markValid(cell, callback);
          } else {
            if (get_messages_only) {
              return messages.join('<br>');
            }
            _this.markInvalid(cell, callback);
            if (_this.hot.check_completion) {
              return _this.setProductCompletion(product, false);
            }
          }
        };
      })(this));
    };

    RatingsDialogController.prototype._checkCellCompletion = function(cell, callback, run_completion_check, get_messages_only) {
      var cell_is_complete, column, messages, product, promise;
      if (callback == null) {
        callback = null;
      }
      if (run_completion_check == null) {
        run_completion_check = true;
      }
      if (get_messages_only == null) {
        get_messages_only = false;
      }
      column = this.all_columns[cell.prop];
      if (column.completion_rules.length === 0) {
        if (get_messages_only) {
          return 'No error';
        }
        this.markValid(cell, callback);
        if (!this.validating_all_cells && run_completion_check) {
          product = this._getProductAtCell(cell);
          this.checkIfProductIsComplete(product, cell);
        }
        return;
      }
      product = this._getProductAtCell(cell);
      cell_is_complete = true;
      messages = [];
      promise = this.q((function(_this) {
        return function(resolve, reject) {
          var j, len, ref, results, rule_str, rules_finished;
          if (column.completion_rules.length === 0) {
            resolve();
          }
          rules_finished = 0;
          ref = column.completion_rules;
          results = [];
          for (j = 0, len = ref.length; j < len; j++) {
            rule_str = ref[j];
            results.push(_this.validator.validate(rule_str, cell, product, column, get_messages_only, function(is_valid, msg) {
              if (msg == null) {
                msg = null;
              }
              if (!is_valid) {
                cell_is_complete = false;
                if (get_messages_only && (msg != null)) {
                  messages.push(msg);
                }
              }
              rules_finished++;
              if (rules_finished === column.completion_rules.length) {
                return resolve();
              }
            }));
          }
          return results;
        };
      })(this));
      return promise.then((function(_this) {
        return function() {
          if (cell_is_complete) {
            if (get_messages_only) {
              return 'No error';
            }
            _this.markValid(cell, callback);
            if (!_this.validating_all_cells && run_completion_check) {
              return _this.checkIfProductIsComplete(product, cell);
            }
          } else {
            if (get_messages_only) {
              return messages.join('<br>');
            }
            _this.markIncomplete(cell, callback);
            return _this.setProductCompletion(product, false);
          }
        };
      })(this));
    };

    RatingsDialogController.prototype.getValidationMessage = function(elem) {
      var cell, coords;
      coords = this.hot.getCoords(elem);
      cell = {
        value: this.hot.getDataAtCell(coords.row, coords.col),
        row: coords.row,
        prop: this.hot.colToProp(coords.col)
      };
      return this.validateCell(cell, null, true, true);
    };

    RatingsDialogController.prototype.getValidationMessageWrapper = function(event, api) {
      return this.getValidationMessage(api.target[0]);
    };

    RatingsDialogController.prototype.markInvalid = function(cell, callback) {
      var ref;
      if (callback == null) {
        callback = null;
      }
      if ((ref = this._getProductAtCell(cell)) != null) {
        ref["_" + cell.prop + "_validation"] = {
          status: 'invalid',
          message: this.getValidationMessageWrapper
        };
      }
      if (typeof callback === "function") {
        callback(true);
      }
      this.updateValidationAlert('invalid');
      return false;
    };

    RatingsDialogController.prototype.markIncomplete = function(cell, callback) {
      var ref;
      if (callback == null) {
        callback = null;
      }
      if ((ref = this._getProductAtCell(cell)) != null) {
        ref["_" + cell.prop + "_validation"] = {
          status: 'incomplete',
          message: this.getValidationMessageWrapper
        };
      }
      if (typeof callback === "function") {
        callback(true);
      }
      this.updateValidationAlert();
      return true;
    };

    RatingsDialogController.prototype.markValid = function(cell, callback) {
      var ref;
      if (callback == null) {
        callback = null;
      }
      if ((ref = this._getProductAtCell(cell)) != null) {
        delete ref["_" + cell.prop + "_validation"];
      }
      if (typeof callback === "function") {
        callback(true);
      }
      this.updateValidationAlert();
      return true;
    };

    RatingsDialogController.prototype.getValidationStatus = function(callback) {
      this._cached_validation_status_callbacks.push(callback);
      if (this._getValidationStatusDebounced == null) {
        this._getValidationStatusDebounced = debounce((function(_this) {
          return function() {
            var cached_callback, incomplete, invalid, j, len, ref, status;
            invalid = false;
            incomplete = false;
            (function() {
              var column, j, len, product, prop, ref, ref1, ref2, ref3;
              ref = _this.scope.products;
              for (j = 0, len = ref.length; j < len; j++) {
                product = ref[j];
                ref1 = _this.all_columns;
                for (prop in ref1) {
                  column = ref1[prop];
                  if (((ref2 = product["_" + prop + "_validation"]) != null ? ref2.status : void 0) === 'invalid') {
                    invalid = true;
                    return;
                  }
                  if (((ref3 = product["_" + prop + "_validation"]) != null ? ref3.status : void 0) === 'incomplete') {
                    incomplete = true;
                  }
                }
              }
            })();
            if (invalid) {
              status = 'invalid';
            } else if (incomplete) {
              status = 'incomplete';
            } else {
              status = 'valid';
            }
            ref = _this._cached_validation_status_callbacks;
            for (j = 0, len = ref.length; j < len; j++) {
              cached_callback = ref[j];
              cached_callback(status);
            }
            _this._cached_validation_status_callbacks = [];
            return _this.scope.$apply();
          };
        })(this));
      }
      return this._getValidationStatusDebounced();
    };

    RatingsDialogController.prototype.updateValidationAlert = function(status) {
      if (status == null) {
        status = null;
      }
      if (this.validating_all_cells) {
        return;
      }
      this._cached_validation_statuses.push(status);
      if (this._updateValidationAlertDebounced == null) {
        this._updateValidationAlertDebounced = debounce((function(_this) {
          return function() {
            var j, len, statuses, trigger_resize;
            statuses = ['invalid', 'incomplete', 'valid', null];
            for (j = 0, len = statuses.length; j < len; j++) {
              status = statuses[j];
              if (indexOf.call(_this._cached_validation_statuses, status) >= 0) {
                break;
              }
            }
            if (status == null) {
              _this.getValidationStatus(function(status) {
                return _this.updateValidationAlert(status);
              });
              return;
            }
            switch (status) {
              case 'invalid':
                trigger_resize = _this.scope.alert_type === '';
                _this.showError('Highlighted values are invalid. Hover over them for details. (If you don\'t see any highlighted values, you may have to scroll to find them.)', false);
                break;
              case 'incomplete':
                trigger_resize = _this.scope.alert_type === '';
                _this.showWarning('Highlighted values are required for product recommendations. Hover over them for details. (If you don\'t see any highlighted values, you may have to scroll to find them.)', false);
                break;
              case 'valid':
                trigger_resize = _this.scope.alert_type !== '';
                _this.clearAlert();
                break;
              default:
                throw new Error(status + " is not a valid validation status");
            }
            if (trigger_resize) {
              angular.element(_this.window).trigger('resize');
            }
            _this._cached_validation_statuses = [];
            return _this.scope.$apply();
          };
        })(this));
      }
      return this._updateValidationAlertDebounced();
    };

    RatingsDialogController.prototype.showInvalidCells = function() {
      var col, first_invalid_cell, i, j, k, l, len, len1, m, product, prop, ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, results, row, visible_props;
      visible_props = (function() {
        results = [];
        for (var j = ref = this.hot.getFirstVisibleColumn(), ref1 = this.hot.getLastVisibleColumn(); ref <= ref1 ? j <= ref1 : j >= ref1; ref <= ref1 ? j++ : j--){ results.push(j); }
        return results;
      }).apply(this).map((function(_this) {
        return function(col) {
          return _this.hot.colToProp(col);
        };
      })(this));
      for (row = k = ref2 = this.hot.getFirstVisibleRow(), ref3 = this.hot.getLastVisibleRow(); ref2 <= ref3 ? k <= ref3 : k >= ref3; row = ref2 <= ref3 ? ++k : --k) {
        product = this.hot.getSourceDataAtRow(row);
        for (l = 0, len = visible_props.length; l < len; l++) {
          prop = visible_props[l];
          if (((ref4 = product["_" + prop + "_validation"]) != null ? ref4.status : void 0) === 'invalid') {
            this.hot.selectCellByProp(row, prop);
            return;
          }
        }
      }
      first_invalid_cell = null;
      ref5 = this.scope.products;
      for (i = m = 0, len1 = ref5.length; m < len1; i = ++m) {
        product = ref5[i];
        row = this.hot.getRowOfSourceData(product, i);
        ref6 = this.all_columns;
        for (prop in ref6) {
          col = ref6[prop];
          if (((ref7 = product["_" + prop + "_validation"]) != null ? ref7.status : void 0) === 'invalid') {
            if (first_invalid_cell == null) {
              first_invalid_cell = [row, prop];
            }
            if (row === -1) {
              this.scope.show_inactive_products = true;
            }
            (function(_this) {
              return (function() {
                var category, column, heading, len2, len3, n, o, ref8, ref9;
                column = _this.all_columns[prop];
                ref8 = _this.scope.categories;
                for (n = 0, len2 = ref8.length; n < len2; n++) {
                  category = ref8[n];
                  ref9 = category.headings;
                  for (o = 0, len3 = ref9.length; o < len3; o++) {
                    heading = ref9[o];
                    if (indexOf.call(heading.columns, column) >= 0) {
                      category.active = true;
                      return;
                    }
                  }
                }
              });
            })(this)();
          }
        }
      }
      return this.timeout((function(_this) {
        return function() {
          var ref8;
          return (ref8 = _this.hot).selectCellByProp.apply(ref8, first_invalid_cell);
        };
      })(this));
    };

    RatingsDialogController.prototype.checkIfProductIsComplete = function(product, cell) {
      var column, fn, prop, ref, validators;
      validators = [];
      ref = this.all_columns;
      fn = (function(_this) {
        return function(prop) {
          return validators.push(_this.q(function(resolve, reject) {
            return _this.validateCell({
              value: product[prop],
              row: cell.row,
              index: cell.index,
              prop: prop
            }, function(result) {
              var ref1, ref2;
              if ((ref1 = (ref2 = product["_" + prop + "_validation"]) != null ? ref2.status : void 0) === 'invalid' || ref1 === 'incomplete') {
                return reject();
              } else {
                return resolve();
              }
            }, false);
          }));
        };
      })(this);
      for (prop in ref) {
        column = ref[prop];
        fn(prop);
      }
      return this.q.all(validators).then((function(_this) {
        return function() {
          return _this.setProductCompletion(product, true);
        };
      })(this));
    };

    RatingsDialogController.prototype.setProductCompletion = function(product, val) {
      var old_val;
      old_val = product.is_placeable;
      product.is_placeable = val;
      if (val !== old_val) {
        return this._updateSaveData([[product, 'is_placeable', old_val, val]]);
      }
    };

    RatingsDialogController.prototype._updateSaveData = function(changes) {
      var change, j, len, old_val, product, prop, ref, results, row, save_obj, val;
      results = [];
      for (j = 0, len = changes.length; j < len; j++) {
        change = changes[j];
        if ((change != null ? change.length : void 0) !== 4) {
          continue;
        }
        row = change[0], prop = change[1], old_val = change[2], val = change[3];
        if (!((ref = this.all_columns[prop]) != null ? ref.is_editable : void 0) && prop !== 'is_placeable') {
          continue;
        }
        if ($.isNumeric(row)) {
          product = this.hot.getSourceDataAtRow(row);
        } else if (typeof row === 'object') {
          product = row;
        }
        save_obj = _.head(_.filter(this.save_data, {
          id: product.id
        }));
        if (save_obj != null) {
          results.push(save_obj[prop] = val);
        } else {
          save_obj = {
            id: product.id
          };
          save_obj[prop] = val;
          results.push(this.save_data.push(save_obj));
        }
      }
      return results;
    };

    RatingsDialogController.prototype.save = function() {
      this.validating_all_cells = true;
      this.loader.overMap('Validating ratings...');
      return this.q((function(_this) {
        return function(resolve, reject) {
          return _this.validateAllData().then(function() {
            _this.validating_all_cells = false;
            return _this.getValidationStatus(function(status) {
              var result;
              _this.updateValidationAlert(status);
              if (status === 'valid' || status === 'incomplete') {
                result = _this._doSave();
                resolve(result);
              } else {
                reject();
                _this.showInvalidCells();
              }
              return _this.loader.hideAll();
            });
          });
        };
      })(this));
    };

    RatingsDialogController.prototype._doSave = function() {
      var promise;
      if (!this.save_data.length) {
        this.showInfo('No changes detected since last save');
        return true;
      }
      promise = this.repo.updateRatings(this.scope.selected.crop.lineups_id, this.save_data).then((function(_this) {
        return function(response) {
          var ref, ref1;
          if (((ref = response.status) != null ? ref.type : void 0) !== 'success') {
            _this.showUpdateError('product ratings', (ref1 = response.status) != null ? ref1.msg : void 0);
            return;
          }
          _this.showSuccess('Ratings updated');
          return _this.save_data = [];
        };
      })(this))["catch"]((function(_this) {
        return function(response) {
          return _this.showUpdateError('product ratings');
        };
      })(this));
      return promise;
    };

    RatingsDialogController.prototype.exportToExcel = function(crop) {
      var params;
      params = $.param({
        lineups_id: crop.lineups_id,
        sort_props: this.sort_props,
        sort_direction: this.sort_direction,
        show_inactive: this.scope.show_inactive_products
      });
      this.window.open("backend/portal/ratings/ratings/export?" + params);
    };

    return RatingsDialogController;

  })(DialogController);

}).call(this);
